import router from '@/router';
export default {
  state: {
    selectStep: 0,
    couponInfo: {}
  },
  getters: {},
  mutations: {
    setSelectStep(state: any, num: any) {
      state.selectStep = num;
    },
    setCouponInfo(state: any, data: any) {
      data.couponEffectiveStartTime = router.app.$format(data.couponEffectiveStartTime, 'YYYY-MM-DD').replace(/-/g, '.');
      data.couponEffectiveEndTime = router.app.$format(data.couponEffectiveEndTime, 'YYYY-MM-DD').replace(/-/g, '.');
      data.couponFacePrice = (router.app as any).$currency(Number(data.couponFacePrice).d(100))
      data.infoEffectiveWeeks =
        data.couponEffectiveTimeLimitSwitch == 0
          ? '不限星期'
          : (data.effectiveTimeLimitWeekList || [])
            .map((item: number) => {
              return ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][item - 1];
            })
            .join(',');
      data.infoEffectiveTimes =
        data.couponEffectiveTimeLimitSwitch == 0
          ? '不限时段'
          : (data.effectiveTimeLimitTimeList || [])
            .map((item: any) => item.startTime + '-' + item.endTime)
            .join(',');
      data.infoEffectPrice =
        data.couponEffectiveConditionSwitch == 0
          ? '不限金额'
          : '满' + (router.app as any).$currency(Number(data.couponEffectiveConditionPrice).d(100)) + '元可用'
      state.couponInfo = data
    },
  },
  actions: {
    async getCoponByCode({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('COUPON_INFO_BYCODE', params);
      return { error, success };
    },
    async memberDetail({ commit }: any, params: any) {
      params.entityId = router.app.$global.parentBusinessEntityId ? router.app.$global.parentBusinessEntityId : router.app.$global.tenantId
      params.entityType = router.app.$global.parentBusinessEntityTypeId ? router.app.$global.parentBusinessEntityTypeId : router.app.$global.tenantType
      const { error, success }: any = await router.app.$request('SEARCH_MEMBER_DETAIL', params);
      return { error, success };
    },
    async retreatCouponList({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('COUPON_BYCID_LIST', params);
      return { error, success };
    },
    async couponCodeInfo({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('COUPON_INFO_BYCODE', params);
      if (success && success.data) {
        commit('setCouponInfo', success.data);
      }
      return { error, success };
    },
    async couponRetreat({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('COUPON_RETREAT', params);
      return { error, success };
    },

  }
}